// extracted by mini-css-extract-plugin
export default {"infoButton":"UserMenu__infoButton___Qotc0","avatar":"UserMenu__avatar___GHOmh","popover":"UserMenu__popover___ZK95Q"};